import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";
import AlertOperation from "../commons/AlertOperation";
import { postData } from "../api/AuthenticatedApiCaller";
import { LocationsApi } from "../api/AdminApi";
import OperationResult from "../commons/OperationResult";

export default function LocationAddDialog(props) {

  const [hasError, setHasError] = useState(null)

  const updatedLocation = props.location !== null
    ? JSON.parse(JSON.stringify(props.location))
    : {
      "id": null,
      "grText": "",
      "multiLangText": "",
      "longitude": "",
      "latitude": ""
    }

  async function save() {
    let [data, error] = await postData(LocationsApi.setLocation, updatedLocation);
    if (!error) {
      setHasError(false)
    } else {
      setHasError(true)
    }
    props.save()
  }



  return (
    <Box>
      {hasError !== null && <OperationResult success={!hasError} />}

      <Dialog open={props.open}>
        <DialogTitle>{props.location !== null ? "Edit" : "Create"}</DialogTitle>
        <DialogContent>
          <Stack
            sx={{ width: "100%", height: "100%" }}
            component="paper"
            spacing={4}
          >

            <TextField
              label="International Text"
              defaultValue={updatedLocation.multiLangText}
              onChange={(event) => {
                updatedLocation.multiLangText = event.target.value;
              }}
            />
            <TextField
              label="Greek Text"
              defaultValue={updatedLocation.grText}
              onChange={(event) => {
                updatedLocation.grText = event.target.value;
              }}
            />
            <TextField
              label="Latitude"
              defaultValue={updatedLocation.latitude}
              onChange={(event) => {
                updatedLocation.latitude = event.target.value;
              }}
            />
            <TextField
              label="Longitude Text"
              defaultValue={updatedLocation.longitude}
              onChange={(event) => {
                updatedLocation.longitude = event.target.value;
              }}
            />

          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={save}
          >
            Save
          </Button>
          <Button onClick={props.cancel} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
